import { useEffect } from 'react';
/**
 * A hook that will invoke a callback when the user clicks on something outside
 * of the given ref's current element.
 *
 * Users should take care to wrap the given `onClickAway` handler in their own
 * useCallback wrapper.
 *
 * @usage
 * useClickAway(ref, e => console.log('User clicked outside of', e.target))
 */
export function useClickAway(ref, onClickAway) {
    useEffect(function () {
        var listener = function (e) {
            if (ref.current && !ref.current.contains(e.target)) {
                onClickAway(e);
            }
        };
        document.addEventListener('mousedown', listener);
        return function () { return document.removeEventListener('mousedown', listener); };
    }, [ref, onClickAway]);
}
//# sourceMappingURL=index.js.map